import { useLocalization } from "@fluent/react";
import {
  FILTER_CONFIG,
  FilterChipsType,
  StaticFilterType,
} from "./filterConfig";
import { FilterChip } from "./common";

// recurring payment filter and bulk payment filter is a little different than other filters
// becuz user cant select it from the parent dropdown
// and there's no dropdown when you click on the chip
const StaticFilter = ({
  isActive,
  handleSetActive,
  handleToggleFilter,
  type,
}: StaticFilterType & { type: FilterChipsType }) => {
  const { l10n } = useLocalization();
  const config = FILTER_CONFIG[type];
  const label = l10n.getString(config.labelKey);

  const handleToggleChip = () => {
    handleSetActive(isActive ? "" : type);
  };

  const handleRemoveFilter = () => {
    handleToggleFilter(type);
  };

  return (
    <FilterChip
      isActive={isActive}
      handleToggleChip={handleToggleChip}
      label={label}
      handleUserDismiss={handleRemoveFilter}
    />
  );
};

export default StaticFilter;
